<template>
  <div id="NewFactsheetOptionForm">
    <div class="modal-card fixed-width dtac-font">
      <!-- Modal Title -->
      <header class="modal-card-head">
        <p class="modal-card-title">CREATE NEW FACT SHEET</p>
      </header>
      <!-- Modal Description + Input -->
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <b-field label="Customer Type">
              <div class="block">
                <b-radio v-model="create_option" native-value="new">
                  New
                </b-radio>
                <span style="padding: 0 2rem" />
                <b-radio v-model="create_option" native-value="existing">
                  Existng
                </b-radio>
              </div>
            </b-field>
          </div>
          <div v-if="create_option === 'existing'" class="column is-12">
            <b-field label="Client">
              <b-select
                placeholder="Select a Client"
                v-model="selected_client"
                expanded
              >
                <option
                  v-for="client in client_list"
                  :value="client"
                  :key="client._id"
                >
                  {{ client.full_name }} ( {{ client.nick_name }} )
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </section>
      <!-- Modal Footer -->
      <footer class="modal-card-foot" style="justify-content: flex-end">
        <!-- Button: Create + Save -->
        <button
          class="button is-primary"
          :disabled="isDisableButtonAction"
          @click.prevent="performButtonAction()"
        >
          Create
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import ClientApi from "@/services/ClientApi";
import AlertManager from "@/utils/AlertManager";

export default {
  name: "NewFactsheetOptionForm",
  data() {
    return {
      client_list: null,
      create_option: "new",
      selected_client: null
    };
  },
  computed: {
    isDisableButtonAction: function() {
      switch (this.create_option) {
        case "existing":
          return this.selected_client ? false : true;

        default:
          return false;
      }
    }
  },
  methods: {
    requestGetClientList: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await ClientApi.requestClientList();
      loadingComponent.close();
      if (response.status) {
        this.client_list = response.payload.reverse();
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    },
    performButtonAction: function() {
      let emit_payload = {
        option: this.create_option
      };
      if (this.create_option === "existing") {
        emit_payload.client_id = this.selected_client._id;
      }
      this.$emit("option_selected", emit_payload);
      this.$emit("close");
    }
  },
  async beforeMount() {
    await this.requestGetClientList();
  },
  beforeDestroy() {
    this.client_list = null;
    this.selected_client = null;
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 480px;
  padding: 0 20px;
}
.column {
  padding: 0.5rem;
}
</style>
